/// <reference path="../../typings/index.d.ts"/>

import * as React from "react";
import { Topbar } from '../components/Topbar';
import { ViewPanel } from '../components/ViewPanel';
import { LoginPanel } from '../components/LoginPanel';

export interface AppProps extends React.Props<App> {

}

export interface AppState {
    session?: string;
    email?: string;
    showLogin?: boolean;
    user?: any;
    twitter?: any;
}

const w = window;

export class App extends React.Component<AppProps, AppState> {
    constructor(props: AppProps) {
        super(props);

        this.state = {
            session: null,
            email: null,
            showLogin: true,
            user: null
        };
    }

    private toggleLogin() {
        this.setState({
            showLogin: !this.state.showLogin
        });
    }

    private onLogin(user) {
        this.setState({
            user: user
        });
    }

    public render() {
        return (
            <div className="app">
                <Topbar toggleLogin={this.toggleLogin.bind(this)}/>
                <LoginPanel showLogin={this.state.showLogin} onLogin={this.onLogin.bind(this)} />
                <ViewPanel user={this.state.user} />
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/App.tsx
 **/